import React, { useEffect, useMemo } from 'react';
import AdminSearchTable from '../../Admin/AdminSearchTable';

const FiaSection = ({
    model,
    agtCode,
    polNo,
    ownerName,
    onFilteredRowsChange
}) => {
    // All records from model
    const records = model?.bookOfBusinessFIA || [];

    // Normalize filter values
    const normalizedAgtCode = agtCode?.trim()?.toLowerCase();
    const normalizedPolNo = polNo?.trim()?.toLowerCase();
    const normalizedOwnerName = ownerName?.trim()?.toLowerCase();

    const columns = [
        { label: 'Agent Code', accessor: 'agentCode' },
        { label: 'Policy Number', accessor: 'polNo' },
        { label: 'Application Date', accessor: 'effectiveDate' },
        { label: 'Owner', accessor: 'ownerDisplayName' },
        { label: 'Annuitant', accessor: 'annuitantDisplayName' },
        {
            label: 'Policy Premium',
            accessor: 'policyPremium',
            sortType: 'currency'
        }
        //{ label: 'Crediting Rate', accessor: 'creditingRate' }, // Not needed for FIAs
        //{ label: 'Account Value', accessor: 'accountValue', sortType: 'currency' }, //Removed 20260401 Per Taylor
    ];

    const filteredRecords = useMemo(() => {
        return records
            .filter(r => {
                if (!normalizedAgtCode || normalizedAgtCode === 'all') {
                    return true;
                }

                const code = String(r?.agentCode ?? '')
                    .trim()
                    .toLowerCase();

                return code === normalizedAgtCode;
            })
            .filter(r => {
                if (!normalizedPolNo) {
                    return true;
                }

                const p = String(r?.polNo ?? '')
                    .trim()
                    .toLowerCase();

                return p.includes(normalizedPolNo);
            })
            .filter(r => {
                if (!normalizedOwnerName) {
                    return true;
                }

                const owner = String(r?.ownerDisplayName ?? '')
                    .trim()
                    .toLowerCase();

                return owner.includes(normalizedOwnerName);
            });
    }, [
        records,
        normalizedAgtCode,
        normalizedPolNo,
        normalizedOwnerName
    ]);

    // Send only displayed columns to parent for export
    useEffect(() => {
        const exportRows = filteredRecords.map(record => {
            const exportRow = {};

            columns.forEach(col => {
                exportRow[col.label] = record[col.accessor];
            });

            return exportRow;
        });

        onFilteredRowsChange?.(exportRows);
    }, [filteredRecords, onFilteredRowsChange]);

    if (filteredRecords.length === 0) {
        return (
            <div
                className="container container-section"
                id="claims-history-container"
            >
                <div className="card notfoundbox rounded-3 shadow-lg">
                    <div className="card-body">
                        <div className="flex-container">
                            <h5>No Policies Found</h5>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div
            className="container container-section"
            id="claims-history-container"
        >
            <AdminSearchTable
                columns={columns}
                data={filteredRecords}
            />
        </div>
    );
};

export default FiaSection;